var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m20 26.861-8.139-8.139 1.972-2 4.778 4.778V6.667h2.778V21.5l4.778-4.778 1.972 2L20 26.862ZM9.444 33.333c-.75 0-1.4-.275-1.951-.826-.55-.551-.826-1.201-.826-1.951v-5.64h2.777v5.64h21.112v-5.64h2.777v5.64c0 .75-.275 1.4-.826 1.951-.551.55-1.201.826-1.951.826H9.444Z"
})));
export default SvgDownload;